// Bir iş+kanal icin TUM override kayitlarini sil (ciro kaydi silindiginde
// veya reset icin). Root revize history'sini de tamamen temizler.
export const DELETE_PAST_OVERRIDES_FOR_JOB_CHANNEL = `
  mutation DeletePastOverridesForJobChannel($jobId: uuid!, $ciroKanali: String!) {
    delete_revenue_past_overrides(
      where: { job_id: { _eq: $jobId }, ciro_kanali: { _eq: $ciroKanali } }
    ) {
      affected_rows
    }
  }
`;

// ROOT'un yeni revize kaydi. Her insert yeni history entry — audit trail.
export const INSERT_PAST_OVERRIDE = `
  mutation InsertPastOverride(
    $jobId: uuid!,
    $ciroKanali: String!,
    $overrideMonths: Int!,
    $notes: String,
    $companyId: Int!,
    $createdBy: Int
  ) {
    insert_revenue_past_overrides_one(object: {
      job_id: $jobId,
      ciro_kanali: $ciroKanali,
      override_months: $overrideMonths,
      notes: $notes,
      company_id: $companyId,
      created_by: $createdBy
    }) {
      id
      override_months
      created_at
    }
  }
`;
